import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 组织列表
export const setEnterprises: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.total = payload.total;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.loading = !!payload.loading;
};

// 子组织列表
export const setSubOrgs: Mutation<IModuleState> = (state, payload) => {
  state.subList.data = payload.data;
  state.subList.total = payload.total;
  state.subList.pageNum = payload.pageNum;
  state.subList.pageSize = payload.pageSize;
  state.subList.loading = !!payload.loading;
};

// 已授权列表
export const setAuths: Mutation<IModuleState> = (state, payload) => {
  state.auths.data = payload.data;
  state.auths.total = payload.total;
  state.auths.pageNum = payload.pageNum;
  state.auths.pageSize = payload.pageSize;
  state.auths.loading = !!payload.loading;
};

// 未授权列表
export const setUnAuths: Mutation<IModuleState> = (state, payload) => {
  state.unAuths.data = payload.data;
  state.unAuths.total = payload.total;
  state.unAuths.pageNum = payload.pageNum;
  state.unAuths.pageSize = payload.pageSize;
  state.unAuths.loading = !!payload.loading;
};

// 竞品列表
export const setCompetitors: Mutation<IModuleState> = (state, payload) => {
  state.competitors.data = payload.data;
  state.competitors.total = payload.total;
  state.competitors.pageNum = payload.pageNum;
  state.competitors.pageSize = payload.pageSize;
  state.competitors.loading = !!payload.loading;
};

// 非竞品列表
export const setUnCompetitors: Mutation<IModuleState> = (state, payload) => {
  state.unCompetitors.data = payload.data;
  state.unCompetitors.total = payload.total;
  state.unCompetitors.pageNum = payload.pageNum;
  state.unCompetitors.pageSize = payload.pageSize;
  state.unCompetitors.loading = !!payload.loading;
};

// 详情
export const setEnterpriseDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 设置列表的搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
